// Base64 encoded placeholder images for avatars
// In a production app, you'd use actual images from your assets or a CDN

export const teacherAvatar = 'https://cdn.pixabay.com/photo/2021/06/07/13/46/user-6318011_1280.png'; 
export const userAvatar = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'; 